import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=40ca4d58&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Popover.vue?vue&type=style&index=1&id=40ca4d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca4d58",
  null
  
)

export default component.exports